import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import './Hero.css';

const Hero = ({ onScrollToProjects, onScrollToContact }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.15,
        duration: 0.6,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <div className="hero" id="hero">
      <motion.div
        className="hero-content"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="hero-greeting" variants={itemVariants} custom={0}>
          <h2 className="greeting-text">Hey, I'm George</h2>
        </motion.div>

        <motion.h1 className="mega-title" variants={itemVariants} custom={1}>
          <span className="word word-purple">Full-Stack</span>
          <span className="word word-teal">Developer</span>
          <span className="word word-pink">&</span>
          <span className="word word-lime">CS Student</span>
        </motion.h1>

        <motion.p className="hero-tagline" variants={itemVariants} custom={2}>
          CS student at the University of Piraeus. I ship web and
          mobile products with React, TypeScript, and Java — clean UI, solid architecture.
        </motion.p>

        <motion.div className="hero-actions" variants={itemVariants} custom={3}>
          <motion.button
            className="cta-button"
            onClick={onScrollToProjects}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            View My Work <FaArrowRight style={{ marginLeft: '8px' }} />
          </motion.button>
          <motion.button
            className="cta-button cta-secondary"
            onClick={onScrollToContact}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get in Touch
          </motion.button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Hero;
